module.exports = __webpack_public_path__ + "img/moments.37d22446.svg";